<div>
    <div>
        <label>Status</label>
    </div>
    <div>
        <label>Date</label>
    </div>
</div>

<div>
    <button class="buttons p-2" (click)="filterProduct()">Filter</button>
    <button class="cbuttons p-2" (click)="clearFilter()">Clear</button>
    <button class="cbuttons p-2" (click)="closeDialog()">Cancel</button>
</div>